// extracted by mini-css-extract-plugin
export var acitonButtons = "_ei-0";
export var additionalIcon = "_ei-f";
export var block = "_ei-1";
export var blockContent = "_ei-7";
export var blockDescription = "_ei-8";
export var blockIcon = "_ei-9";
export var blockTitle = "_ei-6";
export var border = "_ei-a";
export var center = "_ei-l";
export var edge = "_ei-b";
export var edgeLabel = "_ei-c";
export var edgePath = "_ei-d";
export var error = "_ei-e";
export var flowchart = "_ei-g";
export var flowchartContent = "_ei-h";
export var highlighted = "_ei-3";
export var hover = "_ei-4";
export var icon = "_ei-i";
export var left = "_ei-m";
export var navButton = "_ei-j";
export var navButtons = "_ei-k";
export var right = "_ei-n";
export var selected = "_ei-2";
export var small = "_ei-5";